import GenericCard from "widgets/cards/generic";
import ScheduleForm, { ScheduleFormType } from "widgets/forms/reports/schedule";
import { reportScheduledAdd } from "api/report";
import { ScheduledReqBody } from "api/types/report";
import { notifySimple } from "providers/toast";
import { setLoading } from "store/appSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { convertUTCToLocalTime } from "util/datelib";

interface MyDocumentProps {
  data?: any;
  step: number;
  setStep: (step: number) => void;
}

const Schedule: React.FC<MyDocumentProps> = ({ data, step, setStep }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const submit = async (formData: ScheduleFormType) => {
    const body: ScheduledReqBody = {
      siteId: data.config.body.siteId,
      reportType: data.config.type,
      description: formData.description,
      config: data.config,
      frequency: formData.frequency,
      dom: formData.dom || 1,
      dow: formData.dow || 1,
      hour: formData.hourOn.hour,
      recipients: formData.recipients.map((recipient: any) => recipient.email),
      intergrations: {},
    };
    dispatch(setLoading(true));
    const { status } = await reportScheduledAdd(body);
    dispatch(setLoading(false));
    if (status && status === 200) {
      notifySimple(t("notification.report.scheduled.success"), "success");
      setStep(3);
    } else {
      notifySimple(t("notification.report.scheduled.error"), "error");
    }
  };
  return (
    <GenericCard
      title={t("reports.schedule.step.title")}
      description={t("reports.schedule.step.description")}
      bgColor="400"
      textColor="white"
      extra="h-full"
    >
      <ScheduleForm
        submit={submit}
        disabled={!data?.config || step === 3 || step === 0}
        values={{
          description: data?.description || "",
          frequency: data?.frequency || "DAILY",
          dom: data?.dom || null,
          dow: data?.dow || null,
          hourOn: data?.hourOn
            ? convertUTCToLocalTime(data.hourOn)
            : { hour: 8, minute: 0 },
          recipients: data?.recipients
            ? [
                data?.recipients.map((recipient: any) => ({
                  email: recipient,
                })),
              ]
            : [],
          emailBody: data?.emailBody || "",
        }}
      />
    </GenericCard>
  );
};

export default Schedule;
